import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Flex from '../Flex'

const propTypes = {
  /** propName description */
  children: PropTypes.any,
  /** classes applied to Column */
  className: PropTypes.string,
  row: PropTypes.bool,
  column: PropTypes.bool,
  auto: PropTypes.bool,
  height: PropTypes.string,
  style: PropTypes.object,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

const defaultProps = {
  width: 0,
}

const Column = ({...props}) => {
  const classes = clsx(props.className)
  return (
    <Flex {...props} isColumn className={classes}>
      {props.children}
    </Flex>
  )
}

Column.defaultProps = defaultProps
Column.propTypes = propTypes
Column.displayName = 'Column'

export default Column
